export default __webpack_public_path__ + "static/media/avatar.0734b00f.png";